<template>
    <el-form-item v-if="communityList && communityList.length > 0" label="Community Group" prop="community_id">
      <el-select-v2 v-model="communityId" placeholder="Select Community" :options="communityList" style="width: 100%"
        @change="$emit('selected-community-id', communityId)" />
    </el-form-item>
  </template>
  
  <script>
  import { ref, watch } from "vue";
//   import store from "@/store";
  
  export default {
    name: "CommunityDropdown",
    props: {
      selected: {
        type: Number,
        default: -1,
      },
    },
    emits: ["selected-community-id"],
    setup(props) {
      let communityId = ref(props.selected);
      if (communityId.value == -1) {
        communityId.value = "";
      }
  
      watch(
        () => props.selected,
        (current) => {
          if (current == -1) communityId.value = "";
          else communityId.value = current;
        }
      );
      return { communityId };
    },
    data() {
      return {
        communityList: [],
      };
    },
    created() {
    //   store
    //     .dispatch("list/getCommunities", { sort: "name", order: "asc" })
    //     .then((res) => {
    //       let communities = [];
    //       if (res.data && res.data.length > 0) {
    //         for (let data of res.data) {
    //             communities.push({ value: data.id, label: data.name })
    //         }
    //       }
    //       this.communityList = communities;
    //     });
        this.communityList = [
            { value: 1, label: "Community 1" },
            { value: 2, label: "Community 2" },
            { value: 3, label: "Community 3" },
        ];
    },
  };
  </script>
  
  <style></style>